import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { StackedHeader } from 'components/DataDisplay';
import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { IconType, IconTypes } from 'components/Icons';
import { Drawer } from 'components/Overlay';
import { selectSharedState } from 'containers/SharedState/selectors';
import { LearnMoreFieldType } from 'containers/SharedState/types';

interface KnowledgeBaseDrawerProps {
  headerTitle: string;
  knowledgeBaseKey: LearnMoreFieldType;
  body: React.ReactNode;
  iconType?: IconType;
  iconFilled?: boolean;
  iconPadding?: number | string;
}

export const KnowledgeBaseDrawer: FC<KnowledgeBaseDrawerProps> = props => {
  const {
    headerTitle,
    knowledgeBaseKey,
    iconType,
    iconFilled,
    iconPadding = 1.5,
  } = props;
  const { learnMore } = useSelector(selectSharedState);
  const { setLearnMore } = useKnowledgeBase();
  return (
    <Drawer
      isOpen={learnMore === knowledgeBaseKey}
      onClose={() => setLearnMore()}
      header={
        <StackedHeader
          upper={headerTitle}
          lower="Knowledge Base"
          type={iconType ?? IconTypes.Documents}
          iconFilled={iconFilled}
          style={{ p: iconPadding }}
        />
      }
      body={
        <Box pt={4} pl={2}>
          {props?.body}
        </Box>
      }
      styles={{ content: { maxWidth: '900px' } }}
    />
  );
};
